var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{attrs:{"show":true}},[_c('b-card',{staticStyle:{"min-height":"100px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }